import dayjs from "dayjs";
import { todayInput } from "../utils/date";

export type SimpleBulkRow = {
  key: string;
  dated: string;
  paidOf?: string;
  paymentOf?: string;
  particulars?: string;
  chequeNo?: string;
  debit?: number | null;
  credit?: number | null;
  remarks?: string;
  narration?: string;
};

export function createSimpleBulkRow(): SimpleBulkRow {
  return {
    key: crypto.randomUUID(),
    dated: todayInput(),
    debit: null,
    credit: null
  };
}

export function normalizePastedDate(value?: string) {
  if (!value?.trim()) return undefined;
  const text = value.trim();
  const iso = /^(\d{4})[-/](\d{1,2})[-/](\d{1,2})$/.exec(text);
  if (iso) return `${iso[1]}-${iso[2].padStart(2, "0")}-${iso[3].padStart(2, "0")}`;
  const indian = /^(\d{1,2})[-/](\d{1,2})[-/](\d{4})$/.exec(text);
  if (indian) return `${indian[3]}-${indian[2].padStart(2, "0")}-${indian[1].padStart(2, "0")}`;
  const fallback = dayjs(text);
  return fallback.isValid() ? fallback.format("YYYY-MM-DD") : undefined;
}

export function parsePastedNumber(value?: string) {
  const numeric = Number(String(value ?? "").replace(/[,\s\u20b9]/g, ""));
  return Number.isFinite(numeric) ? numeric : 0;
}
